import { useContext } from 'react';
import { useGoodsRoute } from '../../../hooks/useGoodsRoute';
import { GoodsParamsContext } from '../context/GoodsParamsContext';

export const useGoodsSno = (): number => {
  const injected = useContext(GoodsParamsContext);
  // route 가 없으면 throw 하는 useRoute 대신 context 를 직접 읽어, 주입(찜탭 등) 케이스를 허용.
  const { params } = useGoodsRoute<'GoodsDetail'>();

  if (injected) {
    return injected.goodsId;
  }

  // const params = params as GoodsRouteParams['GoodsDetail'];
  return params.goodsId;
};
